import { createSelector } from 'reselect';
import Vidi from 'vidi';


const getVideoUrls = props => props.videoUrls;

function toVidiTypes(url, type) {
  if (/mp4/i.test(type)) {
    return { url, type: Vidi.MediaStreamTypes.MP4, name: /[0-9]+p/i.exec(type)[0] };
  }
  if (/mpd/i.test(type)) {
    return { url, type: Vidi.MediaStreamTypes.DASH };
  }
  if (/m3u8/i.test(type)) {
    return { url, type: Vidi.MediaStreamTypes.HLS };
  }
  if (/webm/i.test(type)) {
    return { url, type: Vidi.MediaStreamTypes.WEBM };
  }
  return null;
}

const getVidiUrls = createSelector([
  getVideoUrls,
], videoUrls => _.map(videoUrls, toVidiTypes));

export default getVidiUrls;



// WEBPACK FOOTER //
// ./src/shared/selectors/vidi-urls.js